<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? ((proName | translate) + ('\'s Proposal' | translate)) : ''"
      [canGoBack]="true"
      id="top-nav-height">
      @if (loaded) {
        <tidy-wrapper>
          <tidy-row>
            <tidy-divider />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/icons/number_1_white.svg'"
              class="body-size" />
            <tidy-text
              [actionBody]="(service?.name | titlecase) + ' - ' + planFrequencyName"
              class="white" />
          </tidy-row>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/icons/number_2_white.svg'"
              class="body-size" />
            @if (this.form.value.time) {
              <tidy-text
                [actionBody]="this.form.value.time?.date | parseDateTime:'ddd MMM d'"
                class="white" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'at'"
                  class="white" /><span>&nbsp;</span>
                  <tidy-text
                    [actionBody]="this.form.value.time?.time | parseDateTime:'h:mma'"
                    class="white" />
                }
                @if (!this.form.value.time) {
                  <tidy-text
                    [actionBody]="'Select Time'"
                    class="white" />
                }
              </tidy-row>
              <tidy-button
                [text]="'Confirm & Book'"
                [action]="boundAcceptTime"
                [disabled]="form.invalid"
                class="primary" />
            </tidy-wrapper>
          }
        </tidy-top-nav>
      }
    </ng-template>

    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

    <ng-template #content>
      <tidy-wrapper>

        @if (loaded) {
          <tidy-row>
            <tidy-text
              [body]="proName" /><span>&nbsp;</span>
              <tidy-text
                [body]="'could not help you during the times you requested for a'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="service?.name + '.'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'However they said they can at one of the following times.'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [title]="'Select Time With'" /><span>&nbsp;</span>
                    <tidy-text
                      [title]="proName" /><br>
                    <tidy-text
                      [body]="'@' + addressName" />
                  </tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    @for (day of proposedTimes; track day) {
                      <tidy-card>
                        <tidy-row>
                          <tidy-text
                            [header]="day.date | parseDateTime:'dddd MMM d'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-radio-button
                            formControlName="time"
                            [form]="form.controls.time"
                            [items]="day.times"
                            [(ngModel)]="form.value.time"
                            chunkSize="2" />
                        </tidy-row>
                      </tidy-card>
                    }
                  </form>
                  @if (windowService?.isDesktopRes) {
                    <tidy-button
                      [text]="'Confirm & Book'"
                      [action]="boundAcceptTime"
                      [disabled]="form.invalid"
                      class="primary" />
                  }
                  <tidy-row [align]="'center'">
                    <tidy-text
                      (action)="decline()"
                      class="link red"
                      [body]="'Decline Proposal'" />
                  </tidy-row>
                }
              </tidy-wrapper>
            </ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [style.padding-top.px]="topNavHeight" [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
